<template>
  <div class="row">
    <div class="col-md-12">
      <template v-if="media.sm">
        <el-descriptions :column="1" border direction="vertical">
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            {{ rut | rutFormat }}
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            {{ nombreCompleto }}
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'calendar']"></font-awesome-icon>
              Fecha de nacimiento
            </template>
            {{ fechaNacimiento }}
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
              Correo electrónico
            </template>
            {{ email }}
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
              Domicilio electoral
            </template>
            {{ domicilio }}
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'mobile']"></font-awesome-icon>
              Teléfono celular
            </template>
            {{ telefonoMovil }}
          </el-descriptions-item>
          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'phone']"></font-awesome-icon>
              Teléfono fijo
            </template>
            {{ telefonoFijo }}
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item"
                                v-if="partidosSeleccionado !== null">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'person-booth']"></font-awesome-icon>
              Partido Seleccionado
            </template>
            {{ partidosSeleccionado }}
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item"
                                v-if="estadoRevision !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="estadoTag(codigoEstado)">{{ estadoRevision }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>
      <template v-else>
        <el-descriptions :column="4" border>
          <template slot="title">
            <slot name="title"></slot>
          </template>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-card']"></font-awesome-icon>
              Rut
            </template>
            {{ rut | rutFormat }}
          </el-descriptions-item>
          <el-descriptions-item span="3" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'id-badge']"></font-awesome-icon>
              Nombre solicitante
            </template>
            {{ nombreCompleto }}
          </el-descriptions-item>

          <el-descriptions-item content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'calendar']"></font-awesome-icon>
              Fecha de nacimiento
            </template>
            {{ fechaNacimiento }}
          </el-descriptions-item>
          <el-descriptions-item span="3" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['far', 'envelope']"></font-awesome-icon>
              Correo electrónico
            </template>
            {{ email }}
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'location-arrow']"></font-awesome-icon>
              Domicilio electoral
            </template>
            {{ domicilio }}
          </el-descriptions-item>

          <el-descriptions-item span="2" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'mobile']"></font-awesome-icon>
              Teléfono celular
            </template>
            {{ telefonoMovil }}
          </el-descriptions-item>
          <el-descriptions-item span="2" content-class-name="pp-el-descriptions-item">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'phone']"></font-awesome-icon>
              Teléfono fijo
            </template>
            {{ telefonoFijo }}
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item"
                                v-if="partidosSeleccionado !== null">
            <template slot="label">
              <font-awesome-icon :icon="['fas', 'person-booth']"></font-awesome-icon>
              Partido Seleccionado
            </template>
            {{ partidosSeleccionado }}
          </el-descriptions-item>

          <el-descriptions-item span="4" content-class-name="pp-el-descriptions-item"
                                v-if="estadoRevision !== null">
            <template slot="label">
              <span class="el-icon-bell"></span>
              Estado de revisión
            </template>
            <el-tag :type="estadoTag(codigoEstado)">{{ estadoRevision }}</el-tag>
          </el-descriptions-item>

        </el-descriptions>
      </template>

    </div>
  </div>
</template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {Descriptions, DescriptionsItem, Tag} from "element-ui";
import {ActividadCiudadanoEstadoMixin} from "@/mixins/actividadCiudadanoEstado";

export default {
  name: "RenunciaDetail",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    [Tag.name]: Tag,
  },
  props: {
    rut: {
      type: String,
      required: true
    },
    nombreCompleto: {
      type: String,
      required: true
    },
    domicilio: {
      type: String,
      required: true
    },
    fechaNacimiento: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    telefonoMovil: {
      type: String,
      required: true
    },
    telefonoFijo: {
      type: String,
      required: true
    },
    partidosSeleccionado: {
      type: String,
      required: false,
      default: null
    },
    estadoRevision: {
      type: String,
      required: false,
      default: null
    },
    codigoEstado: {
      type: Number,
      required: false,
      default: 0
    }
  },
  mixins: [
    ScreenSizeMixin,
    ActividadCiudadanoEstadoMixin
  ],
}
</script>

<style lang="scss">
.pp-el-descriptions-item {
  padding: 22px 10px !important;
}
</style>
